<template>
  <div>

    <SubHeader subHeaderTitle="Medios de Verificación" />
    <v-row>
        <v-spacer class="col-xs-0">
        </v-spacer>
        <v-col cols="12" sm="12" md="6">
            <v-btn
                color=""
                dark
                class="mb-2 float-right bg-light-blue"
                
                @click="modalNuevoMV"
            >
                Agregar MV
            </v-btn>
        </v-col>
    </v-row>
    <v-data-table
        :items="mediosVerificacion"
        item-key="id"
        class="elevation-0 mt-4"
        :loading="tableLoading"
        no-data-text="No hay medios de verficación registrados para la pregunta"
        :items-per-page="10"
        dense
        :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-page-first',
            lastIcon: 'mdi-page-last',
            prevIcon: 'mdi-chevron-left',
            nextIcon: 'mdi-chevron-right',
            'items-per-page-text':'Registros por página',
            pageText: '{0}-{1} de {2}' 
        }"
        :headers="respuestasHeaders"
    >
        <template v-slot:item="{ item }">
            <tr>
                <td>
                    {{item.codigo}}
                </td>
                <td>
                    {{item.nombre}}
                </td>
                <td>
                    <v-chip
                        class="ma-2"
                        :color="item.estadosId === 1 ? 'teal' : item.estadosId ===2 ? 'red' : item.estadosId ===3 ? 'blue' : 'red' "
                        text-color="white"
                        small
                    >
                        {{item.estado}}
                    </v-chip>
                </td>
                
                <td>
                    <v-btn class="ma-1 text-capitalize" small tile outlined color="indigo" @click="obtenerMedioVerificacionPregungta(item.id)">
                        <v-icon left>mdi-pencil</v-icon> Actualizar
                    </v-btn>
                   
                </td>
            </tr>
        </template>
    </v-data-table>


    <v-dialog
        v-model="dialogMedio"
        max-width="900px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialogMedio = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarMedio"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosMedio.mediosVerificacionId"
                                :items="medios"
                                class="required"
                                dense
                                outlined
                                :loading="ddMediosLoading"
                                label="Seleccionar Medio de Verificación"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Seleccionar Medio de Verificación'
                                    )
                                ]"                               
                            ></v-select>

                            
                        </v-col>

                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosMedio.principal"
                                :items="principalItems"
                                class="required"
                                dense
                                outlined
                                label="Es Medio de verificación principal?"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Medio de verificación principal'
                                    )
                                ]"                               
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogMedio = false; resetForm()"
                            :disabled="btnRegistroMedio"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0" 
                            :disabled="!validForm" 
                            :loading="btnRegistroMedio"                         
                        >
                            {{btnRegistroMedioText}}
                        </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->

     <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoader"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

  </div>
</template>

<script>
import SubHeader from "@/view/components/subheader/SubHeader";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";


import { OBTENER_MEDIOS_VERIFICACION, OBTENER_MEDIOS_VERIFICACION_POR_PREGUNTA, REGISTRAR_MEDIO_VERIFICACION_PREGUNTA, OBTENER_MEDIO_VERIFIFICACION_PREGUNTA, ACTUALIZAR_MEDIO_VERIFICACION_RESPUESTA } from "@/core/services/store/preguntas/mediosverificacion/medioverificacion.module";

import validations from "@/core/untils/validations.js";
export default {
    name:"AdminMediosVerificacion",
    props: ["idPregunta"],
    components: {
         SubHeader,
         SnackAlert,
         DialogLoader
    },
    data: () => ({
        dialogMedio:false,
        ddMediosLoading:false,
        btnRegistroLoading:false,
        validForm:false,
        btnRegistroMedio:false,
        dialogLoader: false,
        accion:1,
        principalItems: [{id: "SI", nombre: 'SI'}, {id:"NO", nombre: 'NO'}],
        dialogLoaderText: 'Actualizando información',
        medios:[],
        datosMedio:{
            id:0,
            mediosVerificacionId: 0,
            estadosId:0,
            principal:''
        },
        switchItemEstado:true,
        modalTitle: 'Registrar Medio Verificación',
        btnRegistroMedioText: 'Registrar MV',
        tableLoading:false,
        mediosVerificacion:[],
        ...validations,
    }),
    methods:{
        modalNuevoMV(){
            this.dialogMedio=true;
            this.modalTitle= 'Registrar Medio Verificación';
            this.btnRegistroMedioText='Registrar MV';
            this.accion=1;
        },

        resetForm(){
            this.datosMedio={
                mediosVerificacionId: 0,
                estadosId:0
            };
            this.accion=1;
            this.switchItemEstado=true;
        },

        //!Obtener medios de verificacion para asignar
        async obtenerMediosVerificacion(){
            this.medios=[];
            this.ddMediosLoading = true;
            this.medios=[];
            
            this.$store
                .dispatch(OBTENER_MEDIOS_VERIFICACION, 1)
                .then(res => {
                    if(res.status===200){
                    this.medios = this.$store.state.medioverificacion.mediosVerificacion;
                    }
                    this.ddMediosLoading =false;
                })
                .catch(() => {
                    this.ddMediosLoading = false;
                });
        },

        //!Obtener medios de verificacion por pregunta
        async obtenerMediosVerificacionPorPregunta(){
            this.mediosVerificacion=[];

            this.respuestas=[];
            this.tableLoading=true;
            await 
            this.$store.dispatch(OBTENER_MEDIOS_VERIFICACION_POR_PREGUNTA,{estadoId:0, preguntasId: this.idPregunta})
            .then(response => {
                //console.log(response)
                if(response.status==200){
                    this.mediosVerificacion=response.data;
                } else{
                    this.mediosVerificacion=[];
                }   
                this.tableLoading=false;
            })
            .catch(()=>{
                this.tableLoading=false;
            })


            
        },

        //!Registrar un medio de verificacion
        async registrarMedio(){
            console.log(this.accion)
            this.datosMedio.preguntasId = this.idPregunta;
            this.switchItemEstado ? this.datosMedio.estadosId = 1 : this.datosMedio.estadosId = 2;
            this.btnRegistroMedio=true;
            if(this.accion===1){
                await this.$store
                    .dispatch(REGISTRAR_MEDIO_VERIFICACION_PREGUNTA, this.datosMedio)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerMediosVerificacionPorPregunta();
                            this.dialogMedio=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();                                
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroMedio=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroMedio=false;
                    });
            } else {
                await this.$store
                    .dispatch(ACTUALIZAR_MEDIO_VERIFICACION_RESPUESTA, this.datosMedio)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerMediosVerificacionPorPregunta();
                            this.dialogMedio=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroMedio=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroMedio=false;
                    });
            }
        },


        async obtenerMedioVerificacionPregungta(Id){
            
            this.dialogLoader=true;
            this.datosMedio.preguntasId = this.preguntasId;
            //this.idPregunta=Id;
            this.accion=2;
            this.modalTitle='Actualizar Medio de verificación';
            this.btnRegistroMedioText='Actualizar MV';
            //this.activeTab=0;
            await this.$store
                .dispatch(OBTENER_MEDIO_VERIFIFICACION_PREGUNTA, Id)
                .then(res => {
                    if(res.status===200){
                    this.datosMedio = this.$store.state.medioverificacion.medioVerificacion;
                    this.datosMedio.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                    this.dialogMedio = true;     
                    } else{
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoader = false;
                })
                .catch(err => {
                    this.dialogLoader = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido en el proceso, por favor, ponte en contacto con un administrador del sistema. REF: ${err}`);
                });
        },
        async actualizarMedioPregunta(id, nuevoEstadoId){
            this.btnRegistroLoading=true;
            this.dialogLoader=true;
            this.datosMedio={
                mediosVerificacionId: id,
                estadosId:nuevoEstadoId
            };

            await this.$store
                    .dispatch(ACTUALIZAR_MEDIO_VERIFICACION_RESPUESTA, this.datosMedio)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialogRes=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                        this.dialogLoader=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                        this.dialogLoader=false;
                    });

              // console.warn(`Actualizando ${id}`)

        },
    },
    created(){
        this.obtenerMediosVerificacionPorPregunta();
        this.obtenerMediosVerificacion();
    },
    computed: {
        respuestasHeaders() {
            return [
                {
                    text: "Codigo MV",
                    align: "start",
                    sortable: false,
                    value: "codigo"
                },
                {
                    text: "Nombre del medio de verificación",
                    value: "nombreMedioVerificacion",
                    sortable: false,
                },
                {
                    text: "Estado",
                    value: "estadosId",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "actions",
                    sortable: false,
                }
            ]
        },
    }
}
</script>

<style>

</style>